var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9884 22L12.0081 21.9806L12.0089 21.9815L21.2912 12.8248C23.5696 10.5772 23.5696 6.93322 21.2912 4.68567C19.0132 2.4385 15.3201 2.43811 13.0416 4.6845C13.0412 4.68489 13.0408 4.68528 13.0404 4.68566L11.9893 5.72261L10.9596 4.70685C10.9592 4.70647 10.9588 4.70608 10.9584 4.7057C8.67991 2.4593 4.98679 2.45968 2.70879 4.70685C0.430404 6.9544 0.430402 10.5984 2.70879 12.846L11.9884 22ZM12.0089 19.0042L12.0081 19.0033L11.9884 19.0227L4.21785 11.3573C2.7729 9.93192 2.7729 7.62089 4.21786 6.19549C5.66281 4.77009 8.00555 4.77009 9.4505 6.19549L11.9893 8.6999L14.5495 6.1743C15.9945 4.74891 18.3372 4.74891 19.7821 6.17431C21.2271 7.59971 21.2271 9.91074 19.7821 11.3361L12.0089 19.0042Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.b785565dba67f95ca145c341424dd602.svg";
export { ForwardRef as ReactComponent };